import React from "react";
import { QuoteResponse, Installment, PaymentMode, Quote } from "../types/Quote";
import { useNavigate } from "react-router-dom";
import QuoteSummary from "../../payment/QuoteSummary";
import { useQuote } from "../hooks/useQuote";

interface QuoteDetailsProps {
  quote: Quote;
  role: "Admin" | "User";
  status: string;
  serviceRequestId: string;
}

const formatCurrency = (amount: number) =>
  amount.toLocaleString("en-IN", {
    style: "currency",
    currency: "INR",
  });

const QuoteDetails: React.FC<QuoteDetailsProps> = ({
  role,
  status,
  serviceRequestId,
}) => {
  const navigate = useNavigate();
  const { quote, loading } = useQuote(serviceRequestId);
  const quoteData = quote;
  const payment = quoteData?.payment;
  const installments: Installment[] = quoteData?.installments ?? [];

  // ----------------------------
  // Pending balance
  // ----------------------------
  const pendingAmount = payment?.payable ?? 0;

  // ----------------------------
  // Active installment logic
  // ----------------------------
  const activeInstallment = installments.find(
    (inst) => inst.id === quoteData?.active_inst_id
  );

  let canPay = false;

  // 🔹 Installment mode
  if (quoteData?.payment_mode === "installment") {
    canPay =
      quoteData?.payment?.payable > 0 &&
      !!activeInstallment &&
      activeInstallment.active_status === "active" &&
      !["paid", "processing"].includes(activeInstallment.status);
  }

  // 🔹 Single or partial payment mode
  if (
    quoteData?.payment_mode === "full" ||
    quoteData?.payment_mode === "partial"
  ) {
    canPay = (payment?.payable ?? 0) > 0;
  }

  // ----------------------------
  // Render
  // ----------------------------
  return (
    <div className="border rounded bg-gray-50 mb-6">
      {/* Header with actions */}
      <div className="flex justify-between items-center px-4 py-3 bg-gray-200 font-semibold">
        <span>Pending Payment</span>

        <div className="flex gap-3 items-center">
          {/* USER ACTION */}
          {role === "User" && canPay && (
            <button
              onClick={() =>
                navigate(`/service-requests/order/${serviceRequestId}`)
              }
              className="bg-green-600 text-white px-3 py-1.5 rounded hover:bg-green-700 text-sm"
            >
              Pay {formatCurrency(pendingAmount)}
            </button>
          )}

          {/* ADMIN ACTION */}
          {role === "Admin" &&
            (status === "PENDING" || status === "PARTIAL") && (
              <button
                onClick={() => alert("Reminder sent to user!")}
                className="bg-blue-600 text-white px-3 py-1.5 rounded hover:bg-blue-700 text-sm"
              >
                Send Reminder
              </button>
            )}
        </div>
      </div>

      {/* Unified Quote UI */}
      <div className="p-4">
{quoteData && (
  <QuoteSummary
    quote={quoteData}
    showPayments={true}
    showCard={false}
  />
)}
      </div>
    </div>
  );
};

export default QuoteDetails;